// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sprite-icons[data-v-04e58c46]{fill:gray;max-height:35px;max-width:35px}.radio-item[data-v-04e58c46]{margin-top:5px}.radio-item .mdi-radiobox-blank[data-v-04e58c46],.radio-item .mdi-radiobox-marked[data-v-04e58c46]{display:none}.border-radius[data-v-04e58c46]{border:1px solid #37beb0!important;border-radius:20px!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
